"use strict";
// in your main.js, homepage.js or subpage.js use $('SELECTORS').responsiveTables();
// the container will be searched for tables to make responsive

Object.prototype.responsiveTables = function () {
  let tableContainer = document.getElementsByTagName('main')[0];

  document.addEventListener("DOMContentLoaded", function () {
    //Document Ready
    if (!(document.getElementsByTagName('body')[0].classList.contains('dnnEditState'))) {
      tableContainer.querySelectorAll('table').forEach((table) => {

        table.removeAttribute('border');
        table.removeAttribute('cell-spacing');
        table.removeAttribute('cellpadding');

        if (table.querySelectorAll('tbody>tr>th').length > 0) {
          table.querySelector('tbody').insertAdjacentHTML('beforebegin', '<thead><tr></tr></thead>');
          table.querySelectorAll('thead tr').append(table.querySelectorAll('th'));
          table.querySelectorAll('tbody tr:first').remove();
        }

        if (!table.parents('.search-results').length) {
          table.classList.add('responsive-table');
          table.setAttribute('style', '');
        }

        let index = 0;
        table.querySelectorAll('td').forEach((tcell) => {
          index++;
          let responsiveTableHeader = tcell.closest('table').querySelectorAll('th')[index];
          wrapInner(tcell, `<span class="cell-content"></span>`);
          tcell.insertAdjacentHTML('beforebegin', `<span class="cell-heading">${responsiveTableHeader}</span>`);
        });
      });
    }
  });
};